import { Button } from '@winnin/winnin_ui.components.button'

import { DownloadIcon } from 'assets/icons/download'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import type { IExportCsvButtonViewProps } from './export-csv-button.types'
import './export-csv-button.styles.scss'

export const ExportCsvButtonView = ({ handleCSVExport, mutationLoading }: IExportCsvButtonViewProps) => {
  const t = useTranslate()
  return (
    <div className="ExportCSVButton">
      <Button appearance="link" variation="faded" onClick={handleCSVExport} disabled={mutationLoading}>
        <DownloadIcon height="16px" width="16px" />
        {t(TOLGEE_GLOBALS.exportCsv)}
      </Button>
    </div>
  )
}
